<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">	
			<top-nevleft></top-nevleft>
			
		 <b-col class="p-0">
		 <!--<b-row class="breadcrumbrow mt-1 m-0">				
			<b-col>
			 <h5 class="text-center">Admin Dashboard</h5>
			</b-col>				
		 </b-row>-->
		 
		<!-- <b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
					<h3>Product Requests</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill  @click="downloadcsv()"><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Export</b-button>
				</b-col>
			</b-row>
		</b-container> -->
		<b-container fluid class="mt-3 mb-2">
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
					
					
					<b-row class="mt-4 px-3">
							<b-col lg="6" class="text-left">
								 <b-button size="sm ml-3 mr-2" @click="selectAllRows">Select all</b-button> <b-button size="sm mr-2" @click="clearSelected">Clear selected</b-button>
							</b-col>
							
							  
							<b-col lg="6"  class="text-right">
								 <b-button size="sm mr-2" @click="settoActiveproduct">Active Product</b-button>
							<b-button variant="primary" pill  @click="triggerimportcsv()">Update Import Product</b-button>
								 <b-form-file type="file" class="importfile" style="display:none" v-model="product_csv" accept=".csv" @change="uploadfile($event)"></b-form-file>
							</b-col>
						</b-row>
					
						<b-row class="mt-4 px-3">
							<b-col lg="2" class="text-left">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-100">
								</b-form-select>
								
							</b-col>
							<b-col lg="2" class="text-left">
								<span class="mr-2">Brand</span>
								<b-form-select v-model="reg_brand" required size="sm">
									<b-form-select-option value="null">All Brand</b-form-select-option>
									<b-form-select-option v-for="sellerRor in sellerList" :value="sellerRor.brand_name"  :key="sellerRor.user_id" >{{sellerRor.brand_name+' ('+sellerRor.productCount+')'}}</b-form-select-option>
									
								</b-form-select>
							</b-col>
							<b-col lg="2" class="text-left">
								<b-button pill variant="primary" class="mt-4" @click="loadData()" size="sm">Submit</b-button>
							</b-col>
							
							<b-col lg="2"  >
								&nbsp;
							</b-col>
							
							<b-col lg="4"  >
								<b-form-group label="Filter" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm" class="m-0">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" 
								:select-mode="selectMode"
								ref="selectableTable"
								selectable @row-selected="onRowSelected"> 
								
									<!-- <template #cell(selected)="{ rowSelected }">
									
									<template v-if="rowSelected">
									  <span aria-hidden="true">&check;</span>
									  <span class="sr-only">Selected</span>
									</template>
									<template v-else>
									  <span aria-hidden="true">&nbsp;</span>
									  <span class="sr-only">Not selected</span>
									</template>
								  </template> -->
								  
								  <template v-slot:cell(selected)="{ rowSelected }">
										<template v-if="rowSelected">
									  <span aria-hidden="true">&check;</span>
									  <span class="sr-only">Selected</span>
									</template>
									<template v-else>
									  <span aria-hidden="true">&nbsp;</span>
									  <span class="sr-only">Not selected</span>
									</template>
								</template>
								
								
								
									<template v-slot:cell(status)="row">
										<b-badge pill variant="warning" v-if="row.value == 0">WAITING</b-badge>
										<b-badge pill variant="danger" v-else-if="row.value == 1">ACTIVE</b-badge>
										<b-badge pill variant="success" v-else>REJECTED</b-badge>
									</template>
                                    <template v-slot:cell(price)="row">
										<span v-html="row.value"></span>
									</template>
                                    <template v-slot:cell(rating)="row">
										<b-form-rating v-model="row.value" inline no-border readonly show-value show-value-max size="sm" variant="info"></b-form-rating>
									</template>
                                    <template v-slot:cell(thumbnail)="row">
                                        <b-img v-bind="thumbnailProps" rounded alt="" v-if="row.value==''" src="../../assets/icons/blank.svg">{{row}}</b-img>
                                       <!-- <b-img v-bind="thumbnailProps" rounded alt="" v-else :src="$root.MEDIAPATH+'products/'+(row.value).replace('_rg','_th')">{{row}}</b-img> -->
                                        <b-img v-bind="thumbnailProps" rounded alt="" v-else :src="row.value.replace('_rg','_th')">{{row}}</b-img>
                                    </template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="updateStatus(row.item, 1)"><b-icon icon="check2" font-scale="1.8" ></b-icon></b-button>
										<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="updateStatus(row.item, 2)"><b-icon icon="x" font-scale="1.8" ></b-icon></b-button>
										<b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target),tabIndex=0"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button> 
										<b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="$root.previewproduct(row.item, row.index),producturlcreated()"><i class="fa fa-eye" aria-hidden="true"></i></b-button> 
									</template>
								</b-table>
							</b-col>
						</b-row>
						
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
						

			
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		
		<top-footer></top-footer>
	</b-col>
	</b-row>
		
	</b-container>
	
	
	
		
	
	<product-preview :productviewlink="$root.productviewlink"></product-preview>
	<product-add-edit :selectedItem="selectedItem" :filteredCategory="filteredCategory" :brandlist="brandlist" :sizelist="sizelist" :category="category" ></product-add-edit>
	
	</div>
	
</template>
<script>
//import Header from "@/components/admin/Header.vue";
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
import Productpreview from "@/components/product-preview.vue";
import Productaddedit from "@/components/product-add-edit";
//import Multiselect from 'vue-multiselect'
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"product-preview": Productpreview,
		"product-add-edit": Productaddedit,
		//Multiselect,
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
		this.producturlcreated();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },           
			product_inf: {},
			product_infState: {product_image_1:null,
						  product_image_2:null,
						  product_image_3:null,
						  product_image_4:null,
						  product_image_5:null,
						  },
			product_inforder: {
					order_1:1,
					order_2:2,
					order_3:3,
					order_4:4,
					order_5:5},
			/*product_glb: '',*/
			model_maps: {},
			recordUrl: this.$root.WEBAPI+'secureapi/product-requests',
			updateUrl: this.$root.WEBAPI+'secureapi/productstatus-update',
			updateProUrl: this.$root.NEWAPIURL+'sellerapi/productupdatenew',
			insertnewUrl: this.$root.NEWAPIURL+'sellerapi/productinsertnew',
			updateBulkUrl: this.$root.WEBAPI+'secureapi/productstatus-updatebulk',
			getBrandByIdUrl: this.$root.WEBAPI+'secureapi/getBrandById',
			urlCreatProductUri: this.$root.WEBURL+'createProductUrlAll',
			brandlist: [],
			sizelist: [],
			brandlist3:[],
			filteredCategory: [],
			category: [],
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Products',
					active: true
				}
			],
			fields: [
                { key: 'Selected',label: 'Selected'},
                { key: 'id', label: 'ID'},
                { key: 'seller', label: 'Seller'},
               // { key: 'rating', label: 'Seller Rating'},
				{ key: 'title', label: 'Title'},
				{ key: 'sku', label: 'SKU'},
				{ key: 'category', label: 'Category' },
				{ key: 'thumbnail', label: 'Thumbnail',
					formatter: (value, key, item) => { 
						return this.$root.MEDIAAPI+'toolimage/get_image?size=80x80&src='+ item.image;
					}
				},
				{ key: 'price', label: 'Price', class: 'text-right',
					formatter: (value, key, item) => { 
							
							if(item.price>item.special_price && item.special_price!=null ){
								var special_price = item.special_price>0 || item.special_price!=null?item.special_price:0;
								return this.$root.currency()+this.$root.tofixed(special_price,2)+" <del>"+this.$root.currency()+this.$root.tofixed(item.price,2)+"</del>";
							}else{
								return this.$root.currency()+this.$root.tofixed(item.price,2);
							}
						

						
					},
				},
				{ key: 'commission', label: 'Commission', class: 'text-right',
					formatter: (value) => { 
						if(value == '' || value == 0){
							return value = 'N/A';
						}
						return value+'%';
					},
				},{ key: 'stock_qty', label: 'Stock', class: 'text-right',
					formatter: (value) => { 
						if(value == '' || value == 0){
							return value = 'N/A';
						}
						return value;
					},
				},
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],			
			selectedItem: {
				title: '',
				short_description: '',
				description: '',
				sku: '',
				hsn_code: '',
				category: '',
				price: '',
				discount: '',
				product_type:1,
				stock_qty:'',
				stock_status:'',
				product_data:{}, 
				tier_price:[], 
				gallery_images:["","","",""],
				status:'',
				commission:'',
				variation_attributes:[],
				variations:[],
				brand:'',
			}, 
			selectedItemState: {
				title: null,
				short_description: null,
				description:null,
				sku: null,
				hsn_code: null,
				category: null,
				price: null,
				discount: null,
				product_type: null,
				stock_qty:null,
				stock_status:null,
				product_data:{}, 
				tier_price:null, 
				status:null,
				commission:null,
				variation_attributes:null,
				variations:null,
				brand:null,
			},
			emptyItem: {
				id: 0,
				product_id: '',
				title: '',
				short_description: '',
				description: '',
				sku: '',
				hsn_code: '',
				category: '',
				price: '',
				product_type: 1,
				stock_qty:'',
				stock_status:'',
				special_price: '',
				product_data:{},
				tier_price: [],
				gallery_images:["","","","",""],
                status: 0,
                commission: '',
				variation_attributes:[],
				variations:[],
				brand:'',
			},
			counterindex:1,
			deleteImage1:'',
			deleteImage2:'',
			deleteImage3:'',
			deleteImage4:'',
			deleteImage5:'',
			tabIndex: 0,
			commissionError:'Commission is required!',
			selectMode: 'multi',
			selected: [],
			sellerList: [],
			reg_brand:null,
			valueSelect:[],
			optionsSel:[],
			optionsSel2: [{ name: 'Vue.js', language: 'JavaScript' },
        { name: 'Adonis', language: 'JavaScript' },
        { name: 'Rails', language: 'Ruby' },
        { name: 'Sinatra', language: 'Ruby' },
        { name: 'Laravel', language: 'PHP' },
        { name: 'Phoenix', language: 'Elixir' }],
		insertPimportsUrl: this.$root.NEWAPIURL+'sellerapi/productcsvupdateproduct',
		product_csv:[],
		};
	},
	methods: {
		onRowSelected(items) {
			this.selected = items
		  },
		  selectAllRows() {
			this.$refs.selectableTable.selectAllRows()
		  },
		  clearSelected() {
			this.$refs.selectableTable.clearSelected()
		  },
		removeTierPrice(i){
			this.selectedItem.tier_price.splice(i,1);
		},
		addTierPrice(){
			console.log(JSON.stringify(this.selectedItem.tier_price));
			var d = new Date();
			this.selectedItem.tier_price.push({'id':d.getTime(), 'min_qty':0, 'price':0});
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			if(item.product_data){
				this.selectedItem.product_data = JSON.parse(item.product_data);
				//console.log(JSON.stringify(this.selectedItem.product_data));
				this.selectedItem.hsn_code = this.selectedItem.product_data.hsn_code!=''?this.selectedItem.product_data.hsn_code:'';
			}
			if(item.tier_price){
				this.selectedItem.tier_price = JSON.parse(item.tier_price);
			}
			if(item.gallery_images){
				this.selectedItem.gallery_images = JSON.parse(item.gallery_images);
			}
			if(item.variation_attributes){
				this.selectedItem.variation_attributes = item.variation_attributes.split('|');
			}
			if(item.variations){
				this.selectedItem.variations = JSON.parse(item.variations);
			}
			
			/* Get Brand List By Product User ID*/
			//console.log(item.user_id);
			var self =this;
			var productUserId = item.user_id;
			self.axios.post(self.getBrandByIdUrl, {
				accesskey: self.$session.get('access_key'),
				user_id:productUserId
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//console.log('ddd'+response.data.result);
					self.brandlist = response.data.result.brandlist;
					self.sizelist = response.data.result.sizelist;
					//this.brandlist = response.data.result;
					//self.brandlist =response.data.result;
					
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			
			
			
			self.$root.$emit('bv::show::modal', 'my-model', button)
		},
		
		updateStatus(item, status){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to update product!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.updateUrl, {
						accesskey: self.$session.get('access_key'),
                        product_id: item.product_id,
                        status: status
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Update Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		settoActiveproduct(){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to approve all product!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.updateBulkUrl, {
						accesskey: self.$session.get('access_key'),
                        product_id: self.selected,
                        status: 1
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Update Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}else{
							self.$bvToast.toast(response.data.message, {
									title: 'Update Status',
									toaster: 'b-toaster-bottom-right',
									autoHideDelay: 5000,
									variant: 'warning',
									solid: true,
									appendToast: true
								});
						
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
				checkFormValidityBank() {
					//alert('tab');
					var step2=0;
					var step3=0;
					var step4=0;
					var step6=0;
					var step7=0;
					if(this.selectedItem.product_type==2){
						step2 =2;
						step3 =4;
						step4=5;
						step6=7;
						step7=8;
					}else{
						step2 =1;
						step3 =3;
						step4=4;
						step6=6;
						step7=7;
						
					}
					
					if(this.tabIndex==0){
							var valid = true;
							if(this.selectedItem.title.length < 3){
							valid = false;
							this.selectedItemState.title = false;
							}else{
							this.selectedItemState.title= true;
							}
							
							if(this.selectedItem.short_description.length < 3){
							valid = false;
							this.selectedItemState.short_description = false;
							}else{
							this.selectedItemState.short_description= true;
							}
							
							if(this.selectedItem.description.length < 3){
							valid = false;
							this.selectedItemState.description = false;
							}else{
							this.selectedItemState.description= true;
							}
							
							if(this.selectedItem.sku.length < 4){
							valid = false;
							this.selectedItemState.sku = false;
							}else{
							this.selectedItemState.sku= true;
							}
							if(this.selectedItem.hsn_code==''){
							valid = false;
							this.selectedItemState.hsn_code = false;
							}else if(this.selectedItem.hsn_code.length < 4){
							valid = false;
							this.selectedItemState.hsn_code = false;
							}else{
							this.selectedItemState.hsn_code= true;
							}
							
							if(this.selectedItem.category.length < 1){
							valid = false;
							this.selectedItemState.category = false;
							}else{
							this.selectedItemState.category= true;
							}
							
							
							
							/*if(this.selectedItem.product_type==''){
							valid = false;
							this.selectedItemState.product_type = false;
							}else{
							this.selectedItemState.product_type= true;
							} */
							
							if(this.selectedItem.product_type==''){
							valid = false;
							this.selectedItemState.product_type = false;
							}else{
							this.selectedItemState.product_type= true;
							}
							if(valid){
								//tabIndex++;
								this.tabIndex=Number(this.tabIndex)+1;
							}
							
						}else if(this.tabIndex==step2){
							var valid2 = true;
							//console.log(this.selectedItem.stock_status);
							if(this.selectedItem.stock_qty==''){
							valid2 = false;
							this.selectedItemState.stock_qty = false;
							}else{
							this.selectedItemState.stock_qty= true;
							}
							
							if(this.selectedItem.stock_status==''){
							valid2 = false;
							this.selectedItemState.stock_status = false;
							}else{
							this.selectedItemState.stock_status= true;
							}
							
							if(valid2){
								//tabIndex++;
								this.tabIndex=Number(this.tabIndex)+1;
							}
						
						
						}else if(this.tabIndex==step3){
							var valid3 = true;
							//console.log(this.product_inf.product_image_1);
							if(this.selectedItem.gallery_images[0]==''){
								if(typeof this.product_inf.product_image_1==='undefined'){
								valid3 = false; 
									this.product_infState.product_image_1 = false;
								}else{
									this.product_infState.product_image_1= true;
								}
							}
							if(valid3){
								//tabIndex++;
								this.tabIndex=Number(this.tabIndex)+1;
							}
						}else if(this.tabIndex==step4){
							console.log(this.selectedItem.stock_status);
							var valid4 = true;
							if(this.selectedItem.price==''){
							valid4 = false;
							this.selectedItemState.price = false;
							}else{
							this.selectedItemState.price= true;
							}
							if(valid4){
								//tabIndex++;
								this.tabIndex=Number(this.tabIndex)+1;
							}
							
						}else if(this.tabIndex==step6){
							console.log(this.selectedItem.commission);
							var valid6 = true;
							if(this.selectedItem.commission==''){
								valid6 = false;
								//this.commissionError='Min commission 5%!';
								this.selectedItemState.commission = false;
							}
							else if(this.selectedItem.commission<5){
							valid6 = false;
							this.commissionError='Min commission should be 5%!';
							this.selectedItemState.commission = false;
							}else{
							this.selectedItemState.commission= true;
							}
							if(valid6){
								//tabIndex++;
								this.tabIndex=Number(this.tabIndex)+1;
							}
							
						}else if(this.tabIndex==step7){
							console.log(this.selectedItem.brand);
							var valid7 = true;
							if(this.selectedItem.brand==''){
							valid7 = false;
							this.selectedItemState.brand = false;
							}else{
							this.selectedItemState.brand= true;
							}
							if(valid7){
								//tabIndex++;
								this.tabIndex=Number(this.tabIndex)+1;
							}
							
						}else{
							this.tabIndex=Number(this.tabIndex)+1;
						}
						
						
						
					//return valid;
			},

			modalSubmit(bvModalEvt){
				/* if (!this.checkFormValidityBank()) {
					return;
					} */
				var self = this;
				self.loading = true;
				bvModalEvt.preventDefault();
				var submitUrl = "";
				if(self.selectedItem.id == 0){
					submitUrl = self.insertnewUrl;
				}else{
					submitUrl = self.updateProUrl;
				} 

				let formData = new FormData();
				formData.append('imagefile1', this.product_inf.product_image_1);
				formData.append('imagefile2', this.product_inf.product_image_2);
				formData.append('imagefile3', this.product_inf.product_image_3);
				formData.append('imagefile4', this.product_inf.product_image_4);
				formData.append('imagefile5', this.product_inf.product_image_5);
				
				//formData.append('image_order', this.product_inforder);
				this.selectedItem.image_order = this.product_inforder;
				formData.append('data', JSON.stringify(this.selectedItem));
				formData.append('accesskey', this.$session.get('access_key'));

				self.axios.post(submitUrl, formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.$bvModal.hide('my-model');
						self.$bvToast.toast(response.data.message, {
							title: 'Status',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'warning',
							solid: true,
							appendToast: true
						});
						self.product_inf.product_image_1 = '';
						self.product_inf.product_image_2 = '';
						self.product_inf.product_image_3 = '';
						self.product_inf.product_image_4 = '';
						self.product_inf.product_image_5 = '';
						self.initload();
					}
					
				})
				.catch(function (error) {
					alert(error);
				});
			},
		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.products;
					self.sellerList = response.data.result.sellerList;
					self.category = response.data.result.category;
					self.loading = false;
					self.totalRows = self.records.length;
					self.filteredCategory = [];
					self.filterChildCategory(0, 0, 0);
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		loadData(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key'),
				brandName: self.reg_brand
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.products;
					self.sellerList = response.data.result.sellerList;
					self.category = response.data.result.category;
					self.loading = false;
					self.totalRows = self.records.length;
					self.filteredCategory = [];
					self.filterChildCategory(0, 0, 0);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			
			
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "zone_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		},		
		onlyRupees ($event) {
		   //console.log($event.keyCode); //keyCodes value
		   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
		   if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
			  $event.preventDefault();
		   }
		},
		onlyNumber ($event) {
		   //console.log($event.keyCode); //keyCodes value
		   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
		   if(keyCode < 48 || keyCode > 57)  { // 46 is dot
			  $event.preventDefault();
		   }
		},
		imageOrderVAlidate($event) {
		   //console.log($event.keyCode); //keyCodes value
		  // console.log($event.target.value); //keyCodes value
		   
		    /*let regex = /^[0-9]*$/
			  if (!regex.test(el.value)) {
				el.value = el.value.slice(0, -1)
			  }*/
		   
		   
		   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
		   if(keyCode < 48 || keyCode > 57)  { // 46 is dot
			  $event.preventDefault();
		   }
		},
		imageOrderVAlidateP($event) {
		   console.log($event.keyCode); //keyCodes value
		   console.log($event.target.value); //keyCodes value
		   
		    let regex = /^[1-5]*$/
			  if (!regex.test($event.target.value)) {
				$event.target.value = $event.target.value.slice(0, -1);
			  }
		   
		   /*
		   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
		   if(keyCode < 48 || keyCode > 57)  { // 46 is dot
			  $event.preventDefault();
		   }*/
		},onChangeCommission(){
			if(this.selectedItem.commission < 5 && this.selectedItem.commission != 0){
				//this.selectedItem.commission = 5;
			}
		},filterChildCategory(id, index, parentid){
			var self = this;
			var tab = '';
			for (let i = 0; i < index; i++) {
				tab += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
			}
			this.category.forEach(function(field){
				if(field.parent == id){
					var fieldid = field.id;
					if(parentid != 0){
						fieldid = parentid+','+field.id;
					}
					self.filteredCategory.push({ html: tab+field.title, title:field.title, position:field.position, parent:field.parent, value: fieldid });
					
					self.optionsSel.push({ name: tab+field.title, language:field.title,value: fieldid});
					
					self.filterChildCategory(field.id, index+1, fieldid);
				}
			});
			return ;
		},
		/*previewproduct(item, index, button) {
				var self =this;
				
				 //let editor = self.$refs.editor; 
				self.iframe.src='https://www.alluraa.com/product/c0c894ff-1772-4c51-997e-93371a75e5a9'; 
				self.iframe.style = {
				  //position: 'absolute',
				  width: window.innerWidth,
				  height: window.innerHeight,
				 // top: -editor.offsetTop + "px",
				 // left: -editor.offsetLeft + "px",
				}    
				self.iframe.wrapperStyle = {
				  overflow: 'hidden',
				 // height: editor.clientHeight + "px",
				  //width: editor.clientWidth + "px",
				} 
				self.loaded = true;
				
				//var iframe = document.getElementById('pviframe');
				
				//iframe.contentDocument.find(".header").css('display', 'none');
				
				// self.$refs.iframe.contentWindow.header.replace('header2');
				
				console.log(item+','+ index)
				self.$root.$emit('bv::show::modal', 'previewproduct', button);
			},*/
			/* ======= Upload  CSV Import Product ======== */
			triggerimportcsv(){
				document.getElementsByClassName('importfile')[0].querySelector('input').click();
			},
			uploadfile(event){
            var self = this;
            self.loading = true;
            let formData = new FormData();
            formData.append('csvfile', document.getElementsByClassName('importfile')[0].querySelector('input').files[0]);
            formData.append('accesskey', this.$session.get('access_key'));
            self.axios.post(self.insertPimportsUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                    if(response.data.error == 0 || response.data.error == '0') {
                            self.$bvModal.hide('my-model');
                            self.$bvToast.toast(response.data.message, {
                                    title: 'Status',
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 5000,
                                    variant: 'warning',
                                    solid: true,
                                    appendToast: true
                            });
                            self.initload();
                    }
                event.target.value = '';
            }).catch(function (error) {
                    alert(error);
            });
        },
		producturlcreated(){
			var self = this;
			self.axios.post(self.urlCreatProductUri, {
                accesskey: self.$root.customer_info.access_key
                
			}).then(function (response) {
				console.log(response);
				
			
			}).catch(function (error) {
				alert(error);
			}); 
		
		}
		/* ======= ======================= */

	}
}
</script>
<style scoped lang="scss">
	
	
</style>